import { render, staticRenderFns } from "./CandidateInfo.vue?vue&type=template&id=53d304ce&"
import script from "./CandidateInfo.vue?vue&type=script&lang=js&"
export * from "./CandidateInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports